export default __webpack_public_path__ + "static/account-features-image-c5bc01a280ac01580b73a4473d12a658.png";